import { Flex, Text } from "@chakra-ui/react";
import React from "react";

export const ObjectHeaderField: React.FC<{
  label: string;
  value: string | number;
  labelColor?: string;
}> = ({ label, value, labelColor = "gray.800" }) => {
  return (
    <Flex direction="column" mx={5} height={10} justifyContent="flex-start">
      <ObjectHeaderFieldLabel label={label} />
      <Text fontSize="sm" color={labelColor}>
        {value}
      </Text>
    </Flex>
  );
};

export const ObjectHeaderFieldLabel: React.FC<{
  label: string;
}> = ({ label }) => {
  return (
    <Text fontSize="10px" color="gray.500" mb={1}>
      {label}
    </Text>
  );
};
